module.exports = __webpack_public_path__ + "img/etang_verdure(2).43f206c2.webp";